
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création de site web pour toiletteur | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Spécialisée dans le toilettage pour chien, Au museau séduisant, souhaitait une com’ qui lui ressemble et qui met en valeur son savoir-faire et sa passion.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site web, logo",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Au Museau Séduisant",
        },
      ],
    };
  },
};
